import { motion } from "framer-motion";
import Dibya from "../Assets/images/Dibya.jpeg";
import Ashutosh from "../Assets/images/Ashu.jpeg";
import Bibek from "../Assets/images/Bibek.jpeg";

const team = [
  {
    name: "Dibyaprakash Bal",
    role: "Founder ",
    image: Dibya,
    skills: [
      "Full-Stack Web Development",
      "React & Modern Frontend",
      "System Architecture",
      "Performance Optimization",
      "Product Engineering",
    ],
  },
  {
    name: "Ashutosh Behera",
    role: "Founder",
    image: Ashutosh,
    skills: [
      "Brand Identity Design",
      "UI/UX Visual Design",
      "Creative Direction",
      "Marketing Creatives",
      "Design Systems",
    ],
  },
  {
    name: "Bibek Nayak",
    role: "Founder ",
    image: Bibek,
    skills: [
      "Product Architecture",
      "UX Strategy & Research",
      "Digital Marketing Strategy",
      "Growth Planning",
      "Accessibility & Usability",
    ],
  },
];


export default function About() {
  return (
    <section className="pt-40 pb-28 max-w-7xl mx-auto px-6">
      {/* Heading */}
      <motion.div
  whileHover={{ y: -12, rotateX: 6 }}
  transition={{ type: "spring", stiffness: 200 }}
  className="p-6 rounded-2xl bg-white dark:bg-[#0B1022]
  border border-black/5 dark:border-white/10
  shadow-lg hover:shadow-2xl"
>

        <h1 className="text-5xl font-extrabold mb-6">
          About{" "}
          <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
            360Support
          </span>
        </h1>
        <p className="text-lg text-slate-600 dark:text-slate-400">
          We are a digital solutions team focused on building reliable,
          scalable, and user-centric products for modern businesses.
        </p>
      </motion.div>

      {/* Vision & Values */}
      <div className="grid md:grid-cols-2 gap-10 mb-24">
        {[
          {
            title: "Our Vision",
            points: [
              "Empower businesses with reliable digital solutions",
              "Build technology that delivers long-term value",
              "Become a trusted digital partner, not just a vendor",
            ],
          },
          {
            title: "Our Values",
            points: [
              "Transparency & honesty in everything we do",
              "Quality over shortcuts",
              "Continuous learning & improvement",
            ],
          },
        ].map((box, i) => (
          <motion.div
            key={box.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.15 }}
            className="p-8 rounded-2xl bg-white dark:bg-[#0B1022]
            border border-black/10 dark:border-white/15 shadow-md"
          >
            <h3 className="text-xl font-semibold mb-4">{box.title}</h3>
            <ul className="space-y-3 text-slate-600 dark:text-slate-400">
              {box.points.map((p) => (
                <li key={p} className="flex gap-2">
                  <span className="text-blue-600">•</span>
                  {p}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>

      {/* Team Section */}
      <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="text-3xl font-semibold mb-12"
      >
        Leadership & Team
      </motion.h2>

      <div className="grid md:grid-cols-3 gap-10">
        {team.map((member, index) => (
          <motion.div
            key={member.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ y: -12 }}
            transition={{ delay: index * 0.15 }}
            viewport={{ once: true }}
            className="p-8 rounded-2xl bg-white dark:bg-[#0B1022]
            border border-black/10 dark:border-white/15
            shadow-lg text-center"
          >
            {/* IMAGE */}
            <div className="relative w-32 h-32 mx-auto mb-6 group">
  {/* Rotating Gradient Ring */}
  <div
    className="absolute inset-0 rounded-full 
    bg-gradient-to-r from-blue-500 via-indigo-500 to-cyan-400
    animate-spin-slow opacity-80 blur-[1px]"
  />

  {/* Image Wrapper */}
  <div
    className="relative w-full h-full rounded-full overflow-hidden
    bg-white dark:bg-[#050816] p-[3px]
    shadow-xl group-hover:shadow-blue-500/40
    transition-all duration-500"
  >
    <img
      src={member.image}
      alt={member.name}
      className="w-full h-full object-cover object-top rounded-full
      transform group-hover:scale-105 transition duration-500"
    />
  </div>
</div>


            <h3 className="text-xl font-semibold">{member.name}</h3>
            <p className="text-blue-600 text-sm mb-4">{member.role}</p>

            <ul className="text-sm text-slate-600 dark:text-slate-400 space-y-2">
              {member.skills.map((skill) => (
                <li key={skill}>• {skill}</li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
